
import React from "react";

export const variantColumns = [
  {
    key: "name",
    label: "Name",
    render: (variant: any) => {
      // Capitalize and remove underscores
      const formattedName = variant.name
        ?.replace(/_/g, ' ')
        ?.split(' ')
        ?.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        ?.join(' ');
      
      return formattedName || variant.name;
    },
  },
  {
    key: "products",
    label: "Associated Products",
    render: (variant: any) => {
      if (!variant.products || variant.products.length === 0) {
        return <span className="text-muted-foreground">None</span>;
      }
      
      return (
        <div className="flex flex-wrap gap-1">
          {variant.products.map((product: string, index: number) => (
            <span key={index} className="bg-secondary text-secondary-foreground px-2 py-1 rounded-md text-xs">
              {product}
            </span>
          ))}
        </div>
      );
    },
  },
  {
    key: "factories",
    label: "Associated Factories",
    render: (variant: any) => {
      if (!variant.factories || variant.factories.length === 0) {
        return <span className="text-muted-foreground">None</span>;
      }
      
      return (
        <div className="flex flex-wrap gap-1">
          {variant.factories.map((factory: string, index: number) => (
            <span key={index} className="bg-primary/10 text-primary px-2 py-1 rounded-md text-xs">
              {factory}
            </span>
          ))}
        </div>
      );
    },
  },
  // {
  //   key: "image_url",
  //   label: "Image",
  //   render: (variant: any) => {
  //     return variant.image_url ? (
  //       <div className="w-12 h-12 rounded-md overflow-hidden border border-border">
  //         <img
  //           src={variant.image_url}
  //           alt={variant.name}
  //           className="w-full h-full object-cover"
  //         />
  //       </div>
  //     ) : (
  //       <span className="text-muted-foreground">No image</span>
  //     );
  //   },
  // },
  {
    key: "description",
    label: "Description",
    render: (variant: any) => {
      if (!variant.description) return <span className="text-muted-foreground">No description</span>;
      
      // Truncate long descriptions
      return variant.description.length > 100
        ? `${variant.description.substring(0, 100)}...`
        : variant.description;
    },
  },
];
